// extracted by mini-css-extract-plugin
export default {"block":"Checkbox_block__iyMhI","selected":"Checkbox_selected__dSpXb"};